<ng-container *ngIf="item">
  <a *ngIf="!item.link" class="full-width-menu-link" (click)="handleSetDropdown(!isShowDropdown)">
    <div class="h6 capitalize">
      {{item.title}}
      <svg-icon key="arrowDownGrayIcon" fontSize="10px" class="ml-1 text-gray-600"></svg-icon>
    </div>
  </a>
  <div *ngIf="item.title === 'categories'" class="dropdown-cate p-10 max-h-[600px] h-[calc(100vh-83px)] [&>li]:text-sm [&>li]:py-2 fixed inset-0 w-full max-w-full top-[78px] [&_.ant-tabs]:!h-full max-md:pl-0 max-md:[&_ul]:!pl-0 max-md:[&_.ant-menu-submenu-title]:!pl-3 max-md:[&_.ant-menu-submenu-title]:!py-[1.75rem] [&_.ant-tabs-nav-list]:!duration-0 [&_.ant-tabs-nav-list]:!delay-0 bg-white {{isShowDropdown ? 'show' : 'hide'}}">
    <nz-tabset
        nzTabPosition="left"
        nzSelectedIndex="0"
        (nzSelectChange)="log([$event])"
        class="ant-tabs-vertical-custom"
      >
        <nz-tab
          *ngFor="let tab of item.children"
          [nzTitle]="templateTitle"
          [nzDisabled]="tab.disabled"
          (nzSelect)="log(['select', tab])"
          (nzClick)="log(['click', tab])"
          (nzContextmenu)="log(['contextmenu', tab])"
          (nzDeselect)="log(['deselect', tab])"
        >
          <h4 class="mb-8">Browse franchise {{tab.title}}:</h4>
          <div class="grid {{tab.title === 'By Location' ? 'grid-cols-5' : 'grid-cols-4'}} gap-y-6">
            <div *ngFor="let child of tab.children"><a class="flex items-center" routerLink="{{child.link}}" (click)="handleSetDropdown(false)">{{child.title}}<svg-icon *ngIf="child.fire" key="fireIcon" class="text-red-fire ml-1" nz-popover fontSize="24px"></svg-icon></a></div>
          </div>
          <ng-template #templateTitle>
            <h6 class="flex items-center gap-x-0.5 capitalize">
              <svg-icon key="{{tab.icon}}" nz-popover fontSize="24px"></svg-icon>
              {{tab.title}}
              <svg-icon key="arrowRightIcon" nz-popover fontSize="24px"></svg-icon>
            </h6>
          </ng-template>
        </nz-tab>
      </nz-tabset>
  </div>
</ng-container>